
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`How do I use styled-components with `}<inlineCode parentName="h2">{`create-react-app`}</inlineCode>{`?`}</h2>
    <p>{`The basic functionality of the library should work out of the box like any other library.`}</p>
    <p>{`However, if you want to do server-side rendering or take advantage of some of the advanced capabilities of the `}<a parentName="p" {...{
        "href": "/docs/tooling#babel-plugin"
      }}>{`styled-components babel plugin`}</a>{` without ejecting you'll need to set up `}<a parentName="p" {...{
        "href": "https://github.com/timarney/react-app-rewired"
      }}><inlineCode parentName="a">{`react-app-rewired`}</inlineCode></a>{` and `}<a parentName="p" {...{
        "href": "https://github.com/withspectrum/react-app-rewire-styled-components"
      }}><inlineCode parentName="a">{`react-app-rewire-styled-components`}</inlineCode></a>{`.`}</p>
    <h3>{`Babel Macro`}</h3>
    <p>{`As of create-react-app v2, there is now an alternative to setting up `}<inlineCode parentName="p">{`react-app-rewired`}</inlineCode>{` through use of "babel macros". See the `}<a parentName="p" {...{
        "href": "/docs/tooling#babel-macro"
      }}>{`documentation for the styled-components babel macro`}</a>{` for setup and usage.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;